import { createContext, type ReactNode, useContext } from 'react';
import { EMPTY_TUNING, type TuningOverrides } from './tuningOverrides';

/**
 * Provides live tuning overrides to PlayerCharacter / MeshAttachment without
 * threading props through every intermediate component (MovingPlayer,
 * CombatScene3D, etc.). Production renders use the empty default.
 *
 * The Equipment Studio wraps its <PlayerCharacter> in a TuningProvider with
 * its current React state so slider movements push live updates straight
 * into the renderer.
 */
const TuningContext = createContext<TuningOverrides>(EMPTY_TUNING);

export function TuningProvider({ value, children }: { value: TuningOverrides; children: ReactNode }) {
  return <TuningContext.Provider value={value}>{children}</TuningContext.Provider>;
}

export function useTuning(): TuningOverrides {
  return useContext(TuningContext);
}
